import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"
import { celebrateDailyTasks } from "../utils/daily_celebration"

// The checkbox on a row of the home Tasks widget. Ticking it completes the task
// through the same endpoint the Tasks page uses (POST /tasks/:id/complete.json)
// — checked at once, then the row folds away. If the save fails the row comes
// back unchecked, so the widget never shows a task done that is not.
//
// The response's `celebration` is shown, not dropped: the server spends the
// day's 10/25/50 threshold on the completion that crosses it, so a surface that
// ignores it eats the confetti (see Milestones::DailyTasksSurfacesTest).
export default class extends Controller {
    static values = { url: String }

    async complete(event) {
        event.preventDefault()
        if (this.element.classList.contains("is-completed")) return

        this.element.classList.add("is-completed")
        try {
            const response = await fetch(this.urlValue, {
                method: "POST",
                headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
                credentials: "same-origin"
            })
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            const data = await response.json().catch(() => ({}))
            celebrateDailyTasks(data.celebration)
            setTimeout(() => this.element.classList.add("is-leaving"), 450)
            setTimeout(() => this.element.remove(), 800)
        } catch {
            this.element.classList.remove("is-completed")
        }
    }
}
